<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Make It Happen: Surrender Your Fear: Take the Leap: Live On Purpose</title>
<link href="../styles/default.css" rel="stylesheet" type="text/css"/>
<p class="cts" id="p0021-01-0"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><a href="#/Text/contents#con6" id="toc6">PART ONE</a></span></p>
<p class="ct1a"><a href="#/Text/contents#con6">SURRENDER YOUR FEAR</a><span class="right_1" epub:type="pagebreak" id="page_2" title="2"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?8bc85346